import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Avatar } from '@material-ui/core';
import withAll from 'components/base/withAll';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { formatNumber } from 'utils/helpers';
import HorizontalBarHtml from 'components/base/charts/Bar/BarHtml/HorizontalBarHtml';
import { getLegendColor } from 'redux/reports/reducers';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.border.main,
    borderRadius: '0.4rem',
    padding: '1rem',
  },
  avatar: {
    marginRight: '0.8rem',
  },
});

const NULL_VALUE_DISPLAY = '-';

const createInnerLabel = (brandData, verticalPostCount) => (
  `${brandData.name}: ${formatNumber(brandData.postCount / verticalPostCount, '0%', NULL_VALUE_DISPLAY)}`
);

const SelectedBrandChart = ({ classes, topBrands, verticalPostCount }) => (
  <div className={classes.root}>
    <HorizontalBarHtml
      data={{
        values: topBrands.map(v => v.postCount),
        labels: topBrands.map(l => <Avatar className={classes.avatar} alt={l.name} src={l.logo} />),
        colors: topBrands.map((_, i) => getLegendColor(i)),
        barLabels: topBrands.map(v => createInnerLabel(v, verticalPostCount)),
      }}
      maxValue={verticalPostCount}
    />
  </div>
);

SelectedBrandChart.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  topBrands: PropTypes.arrayOf(PropTypes.shape({})),
  verticalPostCount: PropTypes.number.isRequired,
};

SelectedBrandChart.defaultProps = {
  topBrands: [],
};

const mapStateToProps = ({ competitiveReportVerticalBreakdown }) => ({
  topBrands: get(competitiveReportVerticalBreakdown, 'data.selectedBrands', []),
  verticalPostCount: get(competitiveReportVerticalBreakdown, 'data.vertical.postCount'),
});

export default withAll(
  connect(mapStateToProps, null),
  withStyles(styles),
)(SelectedBrandChart);
